import { render } from "./IqraStudentSubscriptionsManagement.vue?vue&type=template&id=b8be5774"
import script from "./IqraStudentSubscriptionsManagement.vue?vue&type=script&lang=js"
export * from "./IqraStudentSubscriptionsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__